import React from 'react';
import { motion } from 'framer-motion';
import { Target, Brain, BarChart3, Lightbulb, MessageSquare } from 'lucide-react';
const tomos = [{
  emoji: '📘',
  title: 'TOMO 1 — Fundamentos de Venta Rápida',
  desc: 'Aprendé a ordenar tu presencia digital, entender a tu cliente ideal y crear una oferta más atractiva para vender con más claridad.'
}, {
  emoji: '📙',
  title: 'TOMO 2 — El Cerebro de IA',
  desc: 'Accedé a 50 prompts listos para usar en ChatGPT y ahorrar tiempo al escribir anuncios, respuestas, publicaciones y textos de venta.'
}, {
  emoji: '📗',
  title: 'TOMO 3 — Anuncios que Facturan',
  desc: 'Conocé la estructura base para crear campañas en Meta Ads y empezar a atraer clientes con una inversión controlada.'
}, {
  emoji: '📕',
  title: 'TOMO 4 — Diseño Pro con IA',
  desc: 'Usá Canva, Midjourney y CapCut para crear piezas visuales más profesionales sin ser diseñador ni contratar a terceros.'
}, {
  emoji: '📒',
  title: 'TOMO 5 — Cierre de Ventas por WhatsApp',
  desc: 'Aplicá un sistema práctico de conversación para responder mejor, sostener el interés y aumentar tus cierres de venta.'
}];
export function WhatIncludes() {
  return <section className="py-10 sm:py-20 px-4 bg-green-950/30 border-t border-green-700/20" data-id="element-240">
      <div className="max-w-4xl mx-auto" data-id="element-241">
        <motion.div initial={{
        opacity: 0,
        y: 5
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-10px'
      }} transition={{
        duration: 0.2
      }} className="text-center mb-8 sm:mb-16" data-id="element-242">
          <span className="text-4xl mb-2 sm:mb-4 block" data-id="element-243">📦</span>
          <h2 className="text-3xl sm:text-4xl font-black text-white mb-4 drop-shadow-lg uppercase" data-id="element-244">
            ¿QUÉ INCLUYE EL MEGA PACK?
          </h2>
          <p className="text-xl text-yellow-300 font-bold mb-2" data-id="element-245">
            +300 módulos organizados en 5 tomos + 3 bonos
          </p>
          <p className="text-white/80 font-medium" data-id="element-246">
            Acceso inmediato · Listo para aplicar
          </p>
          <div className="w-24 h-1 bg-white/20 mx-auto mt-4 sm:mt-8" data-id="element-247"></div>
        </motion.div>

        <div className="space-y-4 sm:space-y-6" data-id="element-248">
          {tomos.map((tomo, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-20px'
        }} transition={{
          duration: 0.2,
          delay: index * 0.05
        }} className="bg-green-950/50 p-6 sm:p-8 rounded-2xl border border-green-700/20 flex flex-col sm:flex-row gap-6 items-start sm:items-center hover:bg-green-950/70 transition-colors" data-id="element-249">
              <div className="text-5xl bg-green-900/40 p-4 rounded-xl border border-green-700/20 shrink-0" data-id="element-250">
                {tomo.emoji}
              </div>
              <div data-id="element-251">
                <h3 className="text-xl sm:text-2xl font-bold text-white mb-2" data-id="element-252">
                  {tomo.title}
                </h3>
                <p className="text-white/80 text-lg leading-relaxed" data-id="element-253">
                  {tomo.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
        <div className="w-full h-px bg-white/10 mt-16" data-id="element-254"></div>
      </div>
    </section>;
}